import { Skeleton } from '@zoopla-eng/zds-components/skeleton';
import { PlaceholderImage } from '@zoopla/assets';
import {
    mainImageWrapperStyle,
    mediaImageStyle,
    skeletonWaveWrapperStyle
} from './image.styles.css';

export type ImageProps = {
    src?: string;
    alt?: string;
    isLoading?: boolean;
    draggable?: boolean;
};

export const Image: React.FC<ImageProps> = ({
    src = PlaceholderImage,
    alt = '',
    isLoading = false,
    draggable = true
}) => (
    <div className={mainImageWrapperStyle}>
        {isLoading ? (
            <div className={skeletonWaveWrapperStyle}>
                <Skeleton.Wave />
            </div>
        ) : (
            <div
                role="img"
                className={mediaImageStyle}
                style={{ backgroundImage: `url(${src})` }}
                aria-label={alt}
                draggable={draggable}
            />
        )}
    </div>
);
